var icon = require('vue-svgicon')
icon.register({
  'ks-icon-bell-outline': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M83.88 86.65H43.12V57.21a20.38 20.38 0 0 1 40.76 0m9.06 24.91V57.21a29.48 29.48 0 0 0-22.65-28.63V25.5a6.79 6.79 0 0 0-13.59 0v3.08a29.43 29.43 0 0 0-22.64 28.63v24.91L25 91.18v4.53h77v-4.53m-38.5 18.11a9.06 9.06 0 0 0 9.06-9.06H54.44a9.06 9.06 0 0 0 9.06 9.06z"/>'
  }
})
